import { useState } from 'react';

import ModalAssociaGrupoUsuario from "../componentes/ModalAssociaGrupoUsuario";
import ModalAssociaRoleCpf from "../componentes/ModalAssociaRoleCpf";
import TituloSessao from "../componentes/TituloSessao";

function ConfiguracoesGerais() {

    const [showModalGrupoUsuario, setShowModalGrupoUsuario] = useState(false)

    return (
        <div className="container-fluid d-flex flex-column align-items-center">
            {/* <TituloSessao titulo="Configuração CPF x Permissão" barraDecorativa={false} tituloAlignStart={false} />
            <ModalAssociaRoleCpf /> */}

            <TituloSessao titulo="Configuração Usuário x Grupo de Usuário" barraDecorativa={false} tituloAlignStart={false} />
            <ModalAssociaGrupoUsuario
                showModalGrupoUsuario={showModalGrupoUsuario}
                setShowModalGrupoUsuario={setShowModalGrupoUsuario}
            />
            <button
                className='btn btn-primary'
                type='submit'
                onClick={ ()=> setShowModalGrupoUsuario(true) }
            >
                ASSOCIAR
            </button>

            {/* <TituloSessao titulo="Atualizar view Indicadores Alcançados e Inalcançados Por Métrica" barraDecorativa={false} tituloAlignStart={false} />
            <div className="d-flex justify-content-center mt-3">
                <button className='btn btn-primary' type='submit'>Atualizar</button>
            </div>
            <TituloSessao titulo="Atualizar view Indicadores Mensais Por Métrica " barraDecorativa={false} tituloAlignStart={false} />
            <div className="d-flex justify-content-center mt-3">
                <button className='btn btn-primary' type='submit'>Atualizar</button>
            </div> */}
        </div>
    );
}

export default ConfiguracoesGerais